import React from 'react';
import StarterSystemCard from './StarterSystemCard';
import { Box, Typography, Divider } from '@mui/material';

interface SocialListeningProps {
  starterSystems: any[];
  loading: boolean;
}

const SocialListening: React.FC<SocialListeningProps> = ({ starterSystems, loading }) => (
  <div
    style={{
      flex: 1,
      minHeight: '68vh', //
      background: '#fff',
      padding: 0,
      width: '100%',
      boxSizing: 'border-box',
    }}
  >
    {/* Header Section */}
 
    {/* Grid Section */}
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
        gap: '20px',
        margin: 0,
        width: '100%',
        justifyItems: 'start',
        alignItems: 'start',
        padding: 0,
        background: '#fff',
      }}
    >
        {starterSystems.length === 0 ? (
          <div style={{ color: '#888', fontSize: 18, marginTop: 20, gridColumn: '1/-1', textAlign: 'center' ,marginLeft:"30px"}}>
            No social listening data found.
          </div>
        ) : (
          starterSystems.map((system, idx) => (
            <StarterSystemCard
              key={system.permalink || `${system.title}${system.description}${idx}`}
              image={system.image}
              media_type={system.media_type}
              title={system.title}
              description={system.description}
              url={system.permalink}
              tagRemoved={system.tagRemoved}
            />
          ))
        )}
      </Box>
  </div>
);

export default SocialListening;
